// extracted by mini-css-extract-plugin
export default {"div":"About_div__sUfI0"};